import React, { useCallback, useState } from 'react';
import { Dialog } from '@mui/material';
import { ClientForm } from './clientForm';
import { AppDialogTitle } from '../../layout/appDialogTitle';
import { addNewClient } from '../../services/api/clientServices';
import { Client } from '../../models/client';
import { AppConfirmationSuccessful } from '../app/confirmation/appConfirmationSuccessful';
import useAppSnackbar from '../../hooks/useAppSnackbar';

interface Props {
  isOpen: boolean;
  onCloseAddDialog(): void;
  onRequestSuccessful(): void;
}

export function ClientDialogAdd({
  isOpen,
  onCloseAddDialog,
  onRequestSuccessful,
}: Props): JSX.Element {
  const { onErrorSnackbar } = useAppSnackbar();
  const [isOpenConfirmation, setIsOpenConfirmation] = useState<boolean>(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    onCloseAddDialog();
    setIsOpenConfirmation(false);
  }, [onCloseAddDialog]);

  const handleAddClient = useCallback(
    (newClient: Client) => {
      setIsLoadingRequest(true);
      addNewClient(newClient)
        .then(() => {
          handleClose();
          onRequestSuccessful();
          setIsOpenConfirmation(true);
        })
        .then(() => {
          setTimeout(() => {
            setIsOpenConfirmation(false);
          }, 1000);
        })
        .catch((error) => {
          return onErrorSnackbar(error as Error);
        })
        .finally(() => setIsLoadingRequest(false));
    },
    [handleClose, onErrorSnackbar, onRequestSuccessful]
  );

  return (
    <>
      <Dialog open={isOpen} sx={{ borderRadius: '5px' }}>
        <AppDialogTitle title="Add client" handleClose={handleClose} />
        <ClientForm
          handleClose={handleClose}
          onSubmit={handleAddClient}
          isLoading={isLoadingRequest}
        />
      </Dialog>

      <AppConfirmationSuccessful
        isOpen={isOpenConfirmation}
        message="Client Added"
        onClose={handleClose}
      />
    </>
  );
}
